import { Pictos } from 'src/components/common/Pictos'
import { BannerFull } from 'src/components/department/BannerFull'
import { BannerMood } from 'src/components/department/BannerMood'
import { NavigateBySports } from 'src/components/department/NavigateBySports'
import { NavigateByCategories } from 'src/components/department/NavigateByCategories'
import type { ComponentProps, ComponentType } from 'react'
import type { DepartmentSections } from 'src/components/department/types/sections'
import GridBanner from 'src/components/home/GridBanner'
import CollectionShelfv2 from 'src/components/restructure/product/shelves/CollectionShelfV2'
import TertiaryBanner from 'src/components/home/TertiaryBanner'
import GenericShelfv2 from 'src/components/restructure/product/shelves/GenericShelfV2'
import { RecommendationProvider } from 'src/components/restructure/product/contexts/Recommendations/recommendations-context'
import { ContentSEO } from 'src/components/sports/ContentSEO'
import { InspiringShowcase } from 'src/components/sections/InspiringShowcase'
import FeaturedProducts from 'src/components/sections/campaign/FeaturedProducts'

interface ServerDataSportPage {
  cmsData: {
    sections: DepartmentSections[]
    pdd?: {
      categorySettings: {
        category: string
      }
    }
  }
}

interface DepartmentPageTemplateProps {
  serverData: ServerDataSportPage
}

function InspiringShowcaseWithoutStatsigGate(
  props: ComponentProps<typeof InspiringShowcase>
) {
  return <InspiringShowcase {...props} ignoreStatsigGate />
}

export function DepartmentPageTemplate(
  props: Readonly<DepartmentPageTemplateProps>
) {
  const COMPONENTS: Record<string, ComponentType<any>> = {
    'Banners Secundários [Home]': GridBanner,
    ' Banner Full [Departamento]': BannerFull,
    ' Banners Mood [Departamento]': BannerMood,
    'Navegue por esporte [Departamento]': NavigateBySports,
    'Navegue por categoria [Departamento]': NavigateByCategories,
    ' Pictos [Departamento]': Pictos,
    ' Vitrine - Nossos queridinhos [Departamento]': CollectionShelfv2,
    'Vitrine Editorial [Campanha]': CollectionShelfv2,
    'Vitrine DY [Departamento]': GenericShelfv2,
    'Banners Terciários [Home]': TertiaryBanner,
    '[Departamento | Campanha] Vitrine Inspiracional':
      InspiringShowcaseWithoutStatsigGate,
    '[Campanha] Produtos em Destaque _2.0': FeaturedProducts,
  }

  const { cmsData } = props.serverData

  if (!cmsData) {
    return null
  }

  const { sections, pdd } = cmsData

  const hasDYShelfOnSections = sections.some(
    (section) => section.name === 'Vitrine DY [Departamento]'
  )

  return (
    <RecommendationProvider
      pageName="pdd"
      engines={hasDYShelfOnSections ? ['dy'] : []}
      categorieName={pdd?.categorySettings?.category ?? ''}
    >
      {sections?.map(({ name, data }, index) => {
        const Component = COMPONENTS[name]

        if (!Component) {
          console.info(
            `Could not find component for block ${name}. Add a new component for this block or remove it from the CMS`
          )

          return <></>
        }

        return (
          <Component
            key={`cms-section-${name}-${index}`}
            {...{ ...data, section: name }}
          />
        )
      })}
      {cmsData && (
        <ContentSEO
          dataCMS={cmsData}
          sectionClassname="section-SEO w-full max-w-[1280px] px-4 restructure-tablet:px-5 restructure-small-desktop:px-0 mx-auto py-[40px] restructure-tablet:py-[48px] restructure-small-desktop:py-[60px]"
        />
      )}
    </RecommendationProvider>
  )
}
